import announcementsDefinition from './module/index.js'
import announcementsPluginDefinition from './plugin/index.js'
import announcementsApiDefinition from './api/index.js'
import {
  allAnnouncementsAtomDefinition,
  shownAnnouncementsAtomDefinition,
  shownForcedAnnouncementsAtomDefinition,
  announcementsFiltersAtomDefinition,
  visibleAnnouncementsAtomDefinition,
} from './atoms/index.js'

const defaultConfig = {
  maxRetries: 2,
  retryDelay: 1000,
  apiUrl: 'https://remote-config.exodus.io/v2/announcements.json',
  filters: {
    //    os,
    //    osVersion,
    //    platform
    //    build,
    //    version,
  },
}

const announcements = (config = Object.create(null)) => {
  config = { ...defaultConfig, ...config }

  return {
    id: 'announcements',
    definitions: [
      { definition: allAnnouncementsAtomDefinition },
      {
        definition: shownAnnouncementsAtomDefinition,
        storage: { namespace: 'announcements' },
        aliases: [{ implementationId: 'unsafeStorage', interfaceId: 'storage' }],
      },
      {
        definition: shownForcedAnnouncementsAtomDefinition,
      },
      {
        definition: announcementsFiltersAtomDefinition,
        config: config.filters,
      },
      { definition: visibleAnnouncementsAtomDefinition },
      {
        definition: announcementsDefinition,
        config: {
          apiUrl: config.apiUrl,
          maxRetries: config.maxRetries,
          retryDelay: config.retryDelay,
        },
      },
      { definition: announcementsPluginDefinition },
      {
        definition: announcementsApiDefinition,
      },
    ],
  }
}

export default announcements
